/* eslint-disable camelcase */
import React from "react";
import { useFormikContext } from "formik";
import { identity } from "lodash";

import { Control, FormValues } from "pages/eligibility/type";

import SelectInput from "./select";


const members = (formValues: FormValues): Array<{ [x: string]: any }> => {
  const hhMembers = (formValues["household_members/household"] || []) as Array<any>;
  const applicantData = Object.entries(formValues)
    .reduce((acc: any, [key, value]: [string, any]) => (
      key.includes("applicant") ? { ...acc, [key]: value } : acc
    ), { uniqueID: "applicant" });
  return [applicantData].concat(hhMembers).map((member) =>
    Object.entries(member || {}).reduce((acc: any, [key, value]: [string, any]) => {
      const formattedKey = key.split("/", 1).pop() || "";
      return { ...acc, [formattedKey]: value };
    }, {}));
};

// const MemberSelect: Control<"FormQuestionHouseholdMember"> =
// (props : HHMembersProps) : JSX.Element => {
// TO DO [VK]:  show error if applicant data is not filled (empty dropdown)
const MemberSelect: Control<"FormQuestionHouseholdMember"> =
(props : any) : JSX.Element | null => {
  const form = useFormikContext<FormValues>();

  const options = members(form.values).map((member) => {
    const { uniqueID, name_first, name_last } = member;
    const label = [name_first, name_last].filter(identity).join(" ");
    return { value: uniqueID, label };
  });

  return <SelectInput {...props} data={{ options }} />;
};

export default MemberSelect;
